import { useEffect } from "react";
import { useMatch, useParams } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import CombineMenu from "../components/common/combineMenu/CombineMenu";
import LoungeHelmet from "../components/common/LoungeHelmet";
import LevelInformation from "../components/common/footer/LevelInformation/LevelInformation";
import FixedFooter from "../components/common/footer/FixedFooter";
import { connectSiteState } from "../recoil/userInfoAtom";
import {
  isDetailState,
  isProfilePageState,
  writingTypeState
} from "../recoil/contentsAtom";
import PopPageComments from "../components/community/PopUp/PopPageComments";
import PopPageWrite from "../components/community/PopUp/PopPageWrite";
import DetailPage from "../pages/DetailPage/DetailPage";

interface IProps {
  title: string;
  children: React.ReactNode;
  isFooter: boolean;
}

function Wrapper(props: IProps) {
  const connectSite = useRecoilValue(connectSiteState);
  const { service_code, profilekey, idx, title } = useParams();
  const LoungeHelmetTitle = props.title === "" && service_code;
  const writingType = useRecoilValue(writingTypeState);
  const isProfilePage = useRecoilValue(isProfilePageState);
  const url = isProfilePage
    ? `/profile/${profilekey}/post/${idx}`
    : `page/${service_code}/${title}/${idx}`;
  const detailMatch = useMatch(url);
  const setIsDetail = useSetRecoilState(isDetailState);

  useEffect(() => {
    if (detailMatch === null) {
      setIsDetail(false);
    } else {
      setIsDetail(true);
    }
  }, [detailMatch]);

  return (
    <div id="wrapper">
      <LoungeHelmet title={LoungeHelmetTitle || props.title} />
      {connectSite === "vfun" && <CombineMenu />}
      {props.children}
      <LevelInformation />
      {props.isFooter && <FixedFooter />}

      {detailMatch && <DetailPage />}
      {writingType === "reply" ? <PopPageComments /> : <PopPageWrite />}
    </div>
  );
}

export default Wrapper;
